ALLOWED_CONTROLLER = 'ui_nodes'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  $('*[data-selector="calendar"]').datepicker();

  type = $('#ui_nodes').data('type')
  if type == "operations"
    aTargets = [ 3, 22 ]
  else if type == "technicians"
    aTargets = [ 1,10 ]
  else
    aTargets = [ 10,29 ]

  uiNodeTable = $('#ui_nodes').dataTable
    sPaginationType: "full_numbers"
    lengthMenu: [ 10, 25, 50, 100, 500, 1000, 10000 ]
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 50
    sAjaxSource: $('#ui_nodes').data('source')
    order: [ [ 0, "desc" ] ]
    aoColumnDefs:
      [ { 'bSortable': false, 'aTargets': aTargets } ]
    fnServerData: _.debounce((sSource, aoData, fnCallback, oSettings) ->
      $.ajax
        dataType: 'json'
        type: 'GET'
        url: sSource
        data: aoData
        success: fnCallback
    , 1200)
  $('#draw-table').click(->
    uiNodeTable.fnDraw()
  )

$(document).ready(ready)
